import React, { Component } from 'react';

// eslint-disable-next-line restrict-imports/restrict-imports
import Select from 'corp/components/UI/Select';
import { PodType } from '@scale/shared-types';

interface SelectTagProps {
  value?: { label: string; value: string }[];
  onChange?: (e: any) => void;
  placeholder: string;
  showTagId: boolean;
  multi?: boolean;
}

export default class SelectTag extends Component<SelectTagProps> {
  static defaultProps = {
    placeholder: 'Select a tag',
    showTagId: true,
  };

  async fetchTags(_search: string) {
    const options = Object.values(PodType).map((podType: PodType) => {
      return {
        label: podType.toString(),
        value: podType.toString(),
      };
    });

    return {
      options,
    };
  }

  render() {
    return <Select {...this.props} loadOptions={this.fetchTags.bind(this)} ignoreCase={false} />;
  }
}
